import { Grid, useMediaQuery } from "@mui/material";
import BreadCrumbComp from "../../components/breadCrumb";
import LaddaButton from "../../components/buttons/laddaButton";
import { useNavigate } from "react-router-dom";

const 

ForeignTradeBoard = () => {
  const navigate = useNavigate();

  const isSmallScreen = useMediaQuery("(max-width:590px)");
  const isMediumScreen = useMediaQuery("(max-width:900px)");

  let buttonHeight = "60px";
  if (isMediumScreen) {
    buttonHeight = "40px";
  } else if (isSmallScreen) {
    buttonHeight = "35px";
  }

  return (
    <div>
      <BreadCrumbComp />

      <div className="searchTitle">
        <h1>DASHBOARD SATISFACCIÓN AL CLIENTE</h1>
      </div>

      <Grid container spacing={2} sx={{ alignItems: "stretch" }}>
        <Grid item xs={12} sm={6} md={4} sx={{ display: "flex", minHeight: buttonHeight }}>
          <LaddaButton
            variant="contained"
            onClick={() => navigate("/foreign_trade_board/import_registration")}
            height={buttonHeight}
            borderRadius="15px"
            width="100%"
            margin="0"
          >
            <div className="IHContainer align-center">
              <p className="button_text">Registro de Importación</p>
            </div>
          </LaddaButton>
        </Grid>
        <Grid item xs={12} sm={6} md={4} sx={{ display: "flex", minHeight: buttonHeight }}>
          <LaddaButton
            variant="contained"
            color="#404040"
            backgroundColor="#F4D658"
            onClick={() =>
              navigate("/foreign_trade_board/nationalization_Time", {
                state: { type: "maintenance", data: {} }
              })
            }
            width="100%"
            borderRadius="15px"
            height={buttonHeight}
            margin="0"
          >
            <div className="IHContainer align-center">
              <p className="button_text">Tiempo de Nacionalización</p>
            </div>
          </LaddaButton>
        </Grid>
        <Grid item xs={12} sm={6} md={4} sx={{ display: "flex", minHeight: buttonHeight }}>
          <LaddaButton
            variant="contained"
            onClick={() =>
              navigate("/foreign_trade_board/importExecution", {
                state: { type: "maintenance", data: {} }
              })
            }
            height={buttonHeight}
            borderRadius="15px"
            width="100%"
            margin="0"
          >
            <div className="IHContainer align-center">
              <p className="button_text">Ejecución de importaciones</p>
            </div>
          </LaddaButton>
        </Grid>
        <Grid item xs={12} sm={6} md={4} sx={{ display: "flex", minHeight: buttonHeight }}>
          <LaddaButton
            variant="contained"
            onClick={() =>
              navigate("/foreign_trade_board/internal_client_satisfaction", {
                state: { type: "maintenance", data: {} }
              })
            }
            height={buttonHeight}
            borderRadius="15px"
            width="100%"
            margin="0"
          >
            <div className="IHContainer align-center">
              <p className="button_text">Satisfacción del Cliente Interno</p>
            </div>
          </LaddaButton>
        </Grid>
        <Grid item xs={12} sm={6} md={4} sx={{ display: "flex", minHeight: buttonHeight }}>
          <LaddaButton
            variant="contained"
            color="#404040"
            backgroundColor="#F4D658"
            onClick={() =>
              navigate("/foreign_trade_board/external_client_satisfaction", {
                state: { type: "maintenance", data: {} }
              })
            }
            width="100%"
            borderRadius="15px"
            height={buttonHeight}
            margin="0"
          >
            <div className="IHContainer align-center">
              <p className="button_text">Satisfacción del Cliente Externo</p>
            </div>
          </LaddaButton>
        </Grid>
      </Grid>
      <div className="table-container"></div>
    </div>
  );
};

export default ForeignTradeBoard;
